<template>
  <v-text-field ref="textField"
                v-model="search"
                :placeholder="placeholder"
                hide-details
                clearable
                single-line
                rounded filled prepend-inner-icon="mdi-magnify"
                dense
                @input="valueChanged"/>
</template>

<script>
export default {
  name: 'Search',
  props: {
    value: {type:String,required:false},
    placeholder: {type:String,required:false}
  },
  data() {
    return {
      search: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.search = newValue;
    }
  },
  mounted () {
    document.onkeydown = e => {
      e = e || window.event
      if (e.keyCode === 191 && /* Forward Slash '/' */ e.target !== this.$refs.textField.$refs.input) {
        e.preventDefault()
        this.$nextTick(() => {
          this.$refs.textField.focus()
        });
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null
  },
  methods: {
    valueChanged() {
      this.$emit('input', this.search);
      this.$emit('change', this.search);
    },
  }
}

</script>
